import React from 'react';
import { AttachmentLayout } from '@/declarations/models/AttachmentLayout';
import { BlockPreviewComponent } from '../../lib/declarations/EditorComponentTypes';
import { useCurrentBlock } from '../CurrentBlockProvider';
import { MediaViewType } from '../../../declarations/models/blocks/MediaViewType';
import { AttachmentsBlock } from '../../../declarations/models/blocks/AttachmentsBlock';

// FIXME: first draft placeholder preview
export const AttachmentsBlockPreview: BlockPreviewComponent = () => {
  const { block } = useCurrentBlock();
  const currentBlock = block as AttachmentsBlock;

  const getViewClass = () => {
    switch (currentBlock?.view) {
      case MediaViewType.LIST:
        return 'row--list';
      default:
        return '';
    }
  };

  const getSkin = () => {
    if (currentBlock?.layout !== AttachmentLayout.SIMPLE) {
      return currentBlock?.skin || 'skin';
    }
    return '';
  };

  const getViewWidth = () => {
    if (currentBlock?.width?.includes('wide') && currentBlock?.layout !== AttachmentLayout.EXTENDED) {
      return 'wide';
    }
    return 'auto';
  };

  return (
    <>
      <div className='article__grid'>
        <section className='article__bodytext'>
          {currentBlock?.visibletitle && <h2>{currentBlock?.title}</h2>}
          <p>{currentBlock?.body}</p>
        </section>
      </div>

      {currentBlock?.listSearch && (
        <div className='article__grid'>
          <div className='form'>
            <label htmlFor='search_attachments' className='form__label'>
              {currentBlock?.listSearchText || 'Søk i listen'}
            </label>
            <div className='form__input input--icon'>
              <input id='search_attachments' type='search' className='search_attachments' />
              <i className='input__icon i-nav-search' />
            </div>
          </div>
        </div>
      )}

      <div className={`row row--attachments-v2 row--list width--${getViewWidth()} ${getViewClass()} ${getSkin()}`}>
        <div className='row__grid'>
          <div className='row__content'>
            {currentBlock?.items?.slice(0, currentBlock?.rowMax || 100).map((item, index) => (
              // eslint-disable-next-line
              <div
                className={`module module--attachment-v2 layout--${currentBlock?.layout || 'normal'}`}
                key={`${item.id}`}>
                <div className='module__grid'>
                  <div className='module__media'>
                    {item?.type === 'image' ? <img alt='' className='attachment__image' src={item?.url} /> : null}

                    {item?.content?.poster?.url ? (
                      <img alt='' className='attachment__image' src={item?.content?.poster?.url} />
                    ) : null}
                    {item?.type === 'document' && !item?.content?.poster?.url && (
                      <i className='attachment__icon'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          height='70px'
                          viewBox='0 -960 960 960'
                          width='70px'
                          fill='#000000'>
                          <path d='M342.96-264.92h274.58v-36.93H342.96v36.93Zm0-158.77h274.58v-36.93H342.96v36.93Zm-76.04 297.54q-25.78 0-43.58-17.8-17.8-17.8-17.8-43.57v-584.96q0-25.77 17.8-43.57t43.74-17.8H580l174.46 173.97v472.19q0 25.94-17.8 43.74t-43.58 17.8H266.92Zm294.93-515.08v-155.69H267.08q-9.23 0-16.93 7.69-7.69 7.69-7.69 16.92v584.62q0 9.23 7.69 16.92 7.7 7.69 16.93 7.69h425.84q9.23 0 16.93-7.69 7.69-7.69 7.69-16.92v-453.54H561.85ZM242.46-796.92v155.69-155.69 633.84-633.84Z' />
                        </svg>
                      </i>
                    )}
                    {item?.type === 'audio' && !item?.content?.poster?.url && (
                      <i className='attachment__icon'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          height='70px'
                          viewBox='0 -960 960 960'
                          width='70px'
                          fill='#000000'>
                          <path d='M430-212.31q32.62 0 55.15-22.54 22.54-22.53 22.54-55.15v-159.23h109.23v-61.54h-140v163.46q-9.46-10.31-21.19-15.34-11.73-5.04-25.73-5.04-32.62 0-55.15 22.54-22.54 22.53-22.54 55.15t22.54 55.15q22.53 22.54 55.15 22.54ZM264.62-120q-27.62 0-46.12-18.5Q200-157 200-184.62v-590.76q0-27.62 18.5-46.12Q237-840 264.62-840H580l180 180v475.38q0 27.62-18.5 46.12Q723-120 695.38-120H264.62ZM560-640v-160H264.62q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v590.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69h430.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93V-640H560ZM240-800v160-160 640-640Z' />
                        </svg>
                      </i>
                    )}
                  </div>
                  <div className='module__content'>
                    <div className='module__head'>
                      <strong>
                        {item.local?.title || item.title
                          ? `${item.local?.title || item.title}.${item.filename?.slice(-3) || ''}`
                          : item.filename}
                      </strong>
                    </div>
                    <div className='module__body'>
                      <p>{item.local?.caption || item?.content?.caption}</p>
                      <ul className='attachment__details'>
                        {item?.content?.credits &&
                          item?.content?.credits?.length > 0 &&
                          item?.content?.credits?.map(
                            (credit) =>
                              credit?.name && (
                                <li key={credit?.name}>
                                  <strong className={credit?.type} />
                                  {credit?.name}
                                </li>
                              ),
                          )}

                        <li>
                          <strong>Type:</strong> {item.mimetype && item.mimetype.split('/')[1]} - {item.type}
                        </li>
                        <li>
                          {item.content?.license_code && (
                            <>
                              <strong>Lisens:</strong> {item.content?.license_code || ''}
                            </>
                          )}
                        </li>
                      </ul>
                    </div>
                    <div className='module__foot'>
                      <div className='module__button button button--download'>Last ned</div>
                      <div className='module__button button button--view'>Vis</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {currentBlock?.rowMax && currentBlock?.rowMax < currentBlock?.items?.length && (
            <div className='row__footer'>
              <div className='article__grid'>
                <div className='button button--primary'>Vis alle ({currentBlock?.items?.length})</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AttachmentsBlockPreview;
